import QuestionGroupsTab from './QuestionGroupsTab';

export default QuestionGroupsTab;
